// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Controller Rollout API
 * Fleet-wide view and control of Rollout CRDs across orchestras
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const ResponseRolloutState = {
  RolloutStateActive: 'Active',
  RolloutStatePaused: 'Paused',
  RolloutStateAborted: 'Aborted',
} as const;
export type ResponseRolloutState =
  (typeof ResponseRolloutState)[keyof typeof ResponseRolloutState];

export function instanceOfResponseRolloutState(value: any): boolean {
  for (const key in ResponseRolloutState) {
    if (Object.prototype.hasOwnProperty.call(ResponseRolloutState, key)) {
      if (
        ResponseRolloutState[key as keyof typeof ResponseRolloutState] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function ResponseRolloutStateFromJSON(json: any): ResponseRolloutState {
  return ResponseRolloutStateFromJSONTyped(json, false);
}

export function ResponseRolloutStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseRolloutState {
  return json as ResponseRolloutState;
}

export function ResponseRolloutStateToJSON(
  value?: ResponseRolloutState | null,
): any {
  return value as any;
}

export function ResponseRolloutStateToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): ResponseRolloutState {
  return value as ResponseRolloutState;
}
